import React from "react";
import { XCircle, X, AlertCircle, Loader2 } from "lucide-react";

/**
 * Cancel Event Modal Component
 * Allows users to cancel an event
 */
const CancelEventModal = ({
  isOpen,
  onClose,
  onConfirm,
  eventName,
  isLoading = false,
}) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm({});
  };

  const handleClose = () => {
    if (!isLoading) {
      onClose();
    }
  };

  return (
    <div className="flex fixed inset-0 z-50 justify-center items-center p-4">
      <div
        className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm transition-opacity"
        onClick={handleClose}
      />
      <div className="relative p-6 w-full max-w-md bg-white rounded-2xl shadow-2xl transform transition-all">
        {/* Header */}
        <div className="flex items-start mb-6 space-x-4">
          <div className="flex-shrink-0 p-3 bg-orange-100 rounded-full">
            <XCircle className="w-6 h-6 text-orange-600" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="mb-1 text-xl font-bold text-gray-900">
              Cancel Event
            </h3>
            <p className="text-sm text-gray-600">
              Are you sure you want to cancel{" "}
              <span className="font-semibold text-gray-900">
                {eventName || "this event"}
              </span>
              ?
            </p>
          </div>
          <button
            onClick={handleClose}
            disabled={isLoading}
            className="flex-shrink-0 p-1 text-gray-400 rounded-lg transition-colors hover:text-gray-600 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Warning Message */}
        <div className="p-4 mb-6 bg-orange-50 rounded-xl border border-orange-100">
          <div className="flex items-start space-x-3">
            <AlertCircle className="w-5 h-5 text-orange-600 flex-shrink-0 mt-0.5" />
            <div className="text-sm text-orange-800">
              <p className="mb-1 font-medium">Important:</p>
              <ul className="space-y-1 list-disc list-inside">
                <li>All ticket holders will be notified automatically</li>
                <li>Refunds will be processed according to your refund policy</li>
                <li>This action cannot be undone</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="flex space-x-3">
          <button
            type="button"
            onClick={handleClose}
            disabled={isLoading}
            className="flex-1 px-4 py-3 font-semibold text-gray-700 bg-gray-100 rounded-xl transition-colors hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Keep Event
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            disabled={isLoading}
            className="flex flex-1 justify-center items-center px-4 py-3 font-semibold text-white bg-orange-600 rounded-xl transition-colors hover:bg-orange-700 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoading ? (
              <>
                <Loader2 className="mr-2 w-4 h-4 animate-spin" />
                Cancelling...
              </>
            ) : (
              "Cancel Event"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelEventModal;

